<template>
    <div class='categroy'>
        <div class="categroy_header">
            <nav>
                <ul class="cl-ul cl-display--flex cl-flex--row cl-flex--wrap cl-align--center">
                    <li>
                        <a href="/" class="home" itemprop="item">
                            <svg class="svg-inline--fa fa-home fa-w-18" aria-hidden="true" focusable="false"
                                data-prefix="fas" data-icon="home" role="img" xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 576 512" data-fa-i2svg="">
                                <path fill="currentColor"
                                    d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z">
                                </path>
                            </svg><!-- <i class="fas fa-home"></i> Font Awesome fontawesome.com -->
                            <span style="display: none;" itemprop="name">首頁</span>
                        </a>
                    </li>
                    <li style="cursor: pointer;" @click="back()">文章專欄</li>
                    <li style="color: #000;">{{ item.title }}</li>
                </ul>
            </nav>
        </div>
        <div class="container">
            <div class="Post-title-wrap"> <svg height="1" width="22" style="overflow:visible;">
                    <line x1="21" y1="20" x2="21" y2="90" style="stroke:#979797;stroke-width:1;shape-rendering:crispEdges;">
                    </line>
                </svg>
                <div class="Post-date"> {{ item.time }} </div>
                <h1 class="Post-title"> {{ item.title }} </h1>
                <p>
                    <img style="width: 100%;"
                        :src="item.img"
                        alt="">
                </p>
            </div>
            <div v-html="item.html">
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
            item: {

            },
        };
    },
    computed: {
        ...mapState('header', ['isarticle', 'article']),
    },
    watch: {},
    methods: {
        back() {
            this.$router.push({ path: '/article' });
        },
    },
    created() {
    },
    mounted() {
        this.item = this.article.find(article => article.id === this.$route.params.id);
    },
}
</script>
<style lang='scss' scoped src="./index.scss"></style>
<style lang='scss' scoped>
::v-deep {
    .html {
        p {
            // margin: 0;
        }

        img {
            display: block;
            width: 100%;
        }
    }
}

.container {
    margin: auto;
    max-width: 800px;
    padding: 0 15px;
    .Post-title-wrap {

        padding-bottom: 12px;

        .Post-date {
            color: #4a4a4a;
            opacity: 0.4;
            font-size: 14px;
            font-weight: 300;
            padding: 9px 9px 9px 30px
        }

        .Post-title {
            font-size: 23px;
            font-weight: bold;
            line-height: 1.5;
            margin: 0;
            text-transform: unset;
            padding: 0 0 9px 30px;
            word-break: break-word;
        }
    }
}
</style>